/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2022 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

import * as React from "react";
import styled from "styled-components";

export const SpectrumCssWrapper: React.FC = (props) => {
  return (
    <div
      style={{ backgroundColor: "var(--spectrum-global-color-static-white)" }}
    >
      {props.children}
    </div>
  );
};

// TODO: Replace these with sp-button
export const ButtonFillLarge = styled.button.attrs<{ className: string }>({
  className: "spectrum-Button spectrum-Button--fill spectrum-Button--sizeL",
})``;

export const ButtonFillXLarge = styled.button.attrs<{ className: string }>({
  className: "spectrum-Button spectrum-Button--fill spectrum-Button--sizeXL",
})``;

export const BodyLarge = styled.div.attrs(() => ({
  className: "spectrum-Body spectrum-Body--sizeL",
}))``;

export const HeadingXXL = styled.h1.attrs({
  className: "spectrum-Heading spectrum-Heading--sizeXXL",
})`
  text-align: left;
  color: var(--spectrum-global-color-gray-900);
`;
